// @flow
import {pathOr} from 'ramda';

import type {ApplicationStoreType, SelectorType} from 'constants/flow/flowTypes';

/**
 * Returns product banner content
 *
 * @param {ApplicationStoreType} store - redux store
 * @return {string} product banner content
 */
export const getProductBannerContent = (store: ApplicationStoreType): string =>
    store.productBanner.content;

/**
 * getProductBannerContentType returns banner content_type
 * @param {ApplicationStoreType} store - redux store
 * @return {'json' | 'html'} content type
 */
export const getProductBannerContentType = (store: ApplicationStoreType): 'json' | 'html' | '' =>
    store.productBanner.contentType;

/**
 * Returns product banner state
 *
 * @param {ApplicationStoreType} store - redux store
 * @return {'pending' | 'rejected' | 'fulfilled'} product banner content
 */
export const getProductBannerState = (
    store: ApplicationStoreType,
): 'pending' | 'rejected' | 'fulfilled' => store.productBanner.state;

/**
 * Returns product banner coupon
 *
 * @type {SelectorType<string>}
 */
export const getProductBannerCoupon: SelectorType<string> = pathOr('', ['productBanner', 'coupon']);
